// extracted by css-extract-rspack-plugin
export default {"show-more-container":"BVMH33d___show-more-container","showMoreContainer":"BVMH33d___show-more-container"};